// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import LicenseChecker from './LicenseChecker/Izenda.LicenseChecker';
import TenantManagement from './TenantManagement/Izenda.TenantManagement';
import Connection from './DataSetup/Connection/Izenda.Connection';
import DataModel from './DataSetup/DataModel/Izenda.DataModel';
import RoleSetup from './RoleSetup/Izenda.RoleSetup';
import AdvancedSettings from './DataSetup/AdvancedSetting/Izenda.AdvancedSettings';
import CopyManagement from './DataSetup/CopyManagement/Izenda.CopyManagement';
import DatabaseMapping from './DataSetup/DatabaseMapping/Izenda.DatabaseMapping';
import UserSetup from './UserSetup/Izenda.UserSetup';
import EmailConfiguration from './SystemConfiguration/Email/Izenda.EmailConfiguration';
import ReportConfiguration from './SystemConfiguration/Report/Izenda.ReportConfiguration';
import Scheduling from './SystemConfiguration/Scheduling/Izenda.Scheduling';
import SecurityPoliciesDetail from './SystemConfiguration/SecurityPolicies/Izenda.SecurityPoliciesDetail';
import NotFound from 'share/components/controls/Izenda.NotFound';
import Import from './DataSetup/Import/Izenda.Import.js';
import ImportHistory from './DataSetup/ImportHistory/Izenda.ImportHistory';

import { get, getOr } from 'lodash/fp';

@connect()
export default class SettingsContent extends Component {
  viewComponents = {
    setupAndLicense: {
      component: LicenseChecker,
      storePath: 'licenseChecker'
    },
    tenantManagement: {
      component: TenantManagement,
      storePath: 'tenantManagement'
    },
    connectionString: {
      component: Connection
    },
    dataModel: {
      component: DataModel,
      storePath: 'dataModel'
    },
    roleSetup: {
      component: RoleSetup
    },
    advanceSettings: {
      component: AdvancedSettings,
      storePath: 'advanceSettings'
    },
    copyManagement: {
      component: CopyManagement
    },
    databaseMapping: {
      component: DatabaseMapping
    },
    import: {
      component: Import
    },
    importHistory: {
      component: ImportHistory
    },
    userSetup: {
      component: UserSetup
    },
    emailConfiguration: {
      component: EmailConfiguration,
      storePath: 'emailConfiguration'
    },
    reportConfiguration: {
      component: ReportConfiguration,
      storePath: 'reportConfiguration'
    },
    scheduling: {
      component: Scheduling,
      storePath: 'schedulingSearch'
    },
    securityPolicies: {
      component: SecurityPoliciesDetail,
      storePath: 'securityPolicies'
    },
    notFound: {
      component: NotFound
    }
  };

  static propTypes = {
    store: PropTypes.object.isRequired,
    params: PropTypes.object,
    hasSetupDatabase: PropTypes.bool
  };

  render() {
    const { params, store, store: { contextMenu: { activeLink } }, hasSetupDatabase } = this.props;
    const info = getOr(this.viewComponents.notFound, activeLink, this.viewComponents);
    const linkStore = get(info.storePath, store);

    return linkStore ? (
      <info.component store={linkStore} params={params} hasSetupDatabase={hasSetupDatabase} />
    ) : (
      <info.component />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/Izenda.SettingsContent.js